// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var OrderId = function (x) {
    return x;
};
var udecodeOrderId = Unscramble.decodeInt1;
var showOrderId = Data_Show.showInt;
var ordOrderId = Data_Ord.ordInt;
var newtypeOrderId = {
    Coercible0: function () {
        return undefined;
    }
};
var eqOrderId = Data_Eq.eqInt;
var encodeOrderId = Foreign_Generic_Class.intEncode;
var decodeOrderId = Foreign_Generic_Class.intDecode;
var asParamOrderId = Restaumatic_RouteAsURL.asParamInt;
export {
    OrderId,
    newtypeOrderId,
    showOrderId,
    eqOrderId,
    ordOrderId,
    encodeOrderId,
    decodeOrderId,
    udecodeOrderId,
    asParamOrderId
};
